import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.section`
  background-color: #ffffff;
  padding: 4rem 1.5rem;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Content = styled.div`
  max-width: 700px;
  text-align: center;
  animation: fadeIn 0.6s ease-out;
`;

const Title = styled.h1`
  font-size: 2.2rem;
  color: #0077cc;
  margin-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.15rem;
  color: #444;
  line-height: 1.6;
  margin-bottom: 1.5rem;
`;

const CTAButton = styled.button`
  background-color: #0077cc;
  color: white;
  padding: 0.9rem 2rem;
  font-size: 1.05rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background-color: #005fa3;
  }
`;

export default function ViewAgradecimentoViagem() {
  const navigate = useNavigate();

  return (
    <Wrapper>
      <Content>
         <Title>✈️ Tudo certo! Estamos buscando sua melhor viagem.</Title>

        <Paragraph>
          Realizamos uma busca inicial por oportunidades compatíveis com seus destinos e períodos
          escolhidos. Neste momento, não encontramos nenhuma disponibilidade exata — mas isso é totalmente
          esperado.
        </Paragraph>

        <Paragraph>
          A boa notícia é que <strong>seu interesse já está registrado no nosso sistema inteligente</strong>.
          A partir de agora, nossa plataforma continuará monitorando automaticamente novas datas,
          destinos e ofertas que combinem com o que você procura.
        </Paragraph>

        <Paragraph>
          Assim que surgir uma oportunidade ideal, você receberá um alerta diretamente no WhatsApp ou e-mail. 
          <br />
          💙 Você está na nossa lista de prioridade.
        </Paragraph>


        <CTAButton onClick={() => navigate("/")}>🏠 Voltar para a página inicial</CTAButton>
      </Content>
    </Wrapper>
  );
}
